import { apiSlice } from "../api/apiSlice";

export const membersApi = apiSlice.injectEndpoints({
    tagTypes: ["UserTeams", "Members"],
    endpoints: (builder) => ({
        getMembers: builder.query({
            query: (id) => `/members?teamId=${id}`,
            providesTags: ["Members"],
        }),
        getUserTeams: builder.query({
            query: (email) => `/members?email=${email}`,
            providesTags: ["UserTeams"],
        }),
        getMemberInTeam: builder.query({
            query: ({ id, email }) => `/members?teamId=${id}&email=${email}`,
        }),
        addMember: builder.mutation({
            query: (data) => ({
                url: "/members",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["UserTeams", "Members"],
        }),
        deleteMember: builder.mutation({
            query: (id) => ({
                url: `/members/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Members"],
        }),
    }),
});

export const {
    useGetMembersQuery,
    useGetUserTeamsQuery,
    useAddMemberMutation,
    useDeleteMemberMutation,
} = membersApi;
